import { Avatar, styled } from '@engyalo/design-system';
import { css, Stack } from '@mui/material';
import { convertHexToRgba } from 'utils/convertHexToRgba';

export const CustomAvatar = styled(Avatar)(
  () => css`
    > div {
      width: 6rem;
      height: 6rem;
    }
  `
);

export const Wrapper = styled(Stack)(
  ({ theme }) => css`
    background-color: ${theme.palette.neutral.var20};
    height: 100dvh;
  `
);

export const SettingsWrapper = styled(Stack)(
  () => css`
    padding: 1.6rem 1.2rem 1.2rem 1.2rem;
    gap: 1.2rem;
    margin: 0 auto;
    width: 100%;
  `
);

export const UserInfoWrapper = styled(Stack)(
  () => css`
    gap: 0.8rem;
    align-items: center;
    justify-content: center;
    padding-top: 2rem;
  `
);

export const LoadingWrapper = styled(Stack)(({ theme }) => {
  const hexColorBackground = theme.palette.neutral.var20;
  const transparency = 0.5;
  return css`
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background-color: ${convertHexToRgba(hexColorBackground, transparency)};
  `;
});
